module.exports = __webpack_public_path__ + "img/Linum_usitatissimum.76992756.jpg";